import type { TranslationResources } from "./en";

export const ptBR: TranslationResources = {
  nav: {
    home: "Início",
    products: "Produtos",
    about: "Sobre",
    blog: "Blog",
    contact: "Contato",
    homeSub: "Comece aqui",
    productsSub: "O que criamos",
    aboutSub: "Quem somos",
    blogSub: "Ideias e ensaios",
    contactSub: "Fale com a gente",
  },
  common: {
    menu: "Menu",
    close: "Fechar",
    studio: "Estúdio de tecnologia",
    madeInBrazil: "Feito no Brasil",
    builtInBrazil: "Feito no Brasil",
    exploreProducts: "Ver produtos",
    getInTouch: "Fale com a gente",
    skipToContent: "Pular para o conteúdo",
  },
  hero: {
    line1: "Tecnologia",
    line2: "para pessoas",
    sub: "Criamos softwares e ferramentas que ajudam pessoas: no social, no educacional e além.",
  },
  features: {
    eyebrow: "No que acreditamos",
    line1: "Feito para",
    line2: "ajudar",
    sub: "Social, educacional ou do dia a dia: o que criamos tem que ajudar de verdade. É o único teste que importa.",
    items: [
      {
        title: "Útil, não só esperto",
        desc: "Toda ferramenta precisa justificar seu lugar tornando algo real mais fácil. Se não ajuda uma pessoa de verdade, não lançamos.",
      },
      {
        title: "Privacidade por padrão",
        desc: "As pessoas confiam seu tempo e seus dados a nós. Coleta mínima, criptografia por padrão, LGPD desde o primeiro dia, sem surpresas.",
      },
      {
        title: "Aberto e honesto",
        desc: "Prioridades públicas, prazos honestos e critérios claros. Você sempre sabe o que estamos criando e por quê.",
      },
    ],
  },
  marquee: [
    "Tecnologia para pessoas",
    "Educação",
    "Comunidade",
    "Acessibilidade",
    "Privacidade por padrão",
    "Centrado nas pessoas",
    "Impacto social",
    "Aberto e honesto",
    "Feito no Brasil",
    "Menos, porém melhor",
  ],
  cta: {
    eyebrow: "O próximo passo",
    heading: "Tem algo em mente",
    sub: "Social, educacional ou algo novo: se ajuda pessoas, a gente quer ouvir.",
    talkToUs: "Fale com a gente",
    seeProducts: "Ver produtos",
  },
  footer: {
    lede: "Softwares e ferramentas que ajudam pessoas: social, educacional e do dia a dia. Feito no Brasil, para todos.",
    index: "Índice",
    backToTop: "Voltar ao topo",
    copyright: "© {{year}} Avoria. Feito no Brasil.",
    privacy: "Privacidade",
    faq: "FAQ",
  },
  about: {
    eyebrow: "Filosofia",
    side: "Quem somos",
    title: "A filosofia por trás da Avoria",
    sub: "A Avoria existe por um motivo: criar softwares e ferramentas que ajudam pessoas de verdade na forma como aprendem, se conectam e vivem. Sem pressa, mas com propósito.",
    manifestoLabel: "( O Manifesto )",
    manifesto: [
      "Criamos para ajudar pessoas, sempre em primeiro lugar.",
      "Conectamos as partes, para que o todo faça sentido.",
      "Protegemos as pessoas, para que a confiança exista.",
    ],
    manifestoFoot: "Manifesto Avoria. Ajudar primeiro, com clareza e propósito.",
    nameLabel: "( O Nome )",
    nameTitle: 'Por que o nome "Avoria"?',
    namePara1:
      "Avoria é uma síntese de <aurora>aurora</aurora> (o amanhecer de um novo ciclo) e <avorio>avorio</avorio> (marfim, pureza e resiliência). Representa o ponto onde o racional e o estético se encontram: tecnologia com alma, engenharia com ética.",
    namePara2:
      "Assim como a aurora anuncia o dia, a Avoria quer ser um começo: uma nova forma de construir software, centrada nas pessoas, na clareza e no propósito.",
    philTitle: "Nossa filosofia",
    philSub: "Cinco coisas em que acreditamos.",
    pillars: [
      {
        title: "Pessoas em primeiro lugar",
        desc: "Criamos softwares e ferramentas para ajudar pessoas de verdade na educação, na comunidade e no dia a dia. Isso vem antes de tudo.",
      },
      {
        title: "Menos, porém melhor",
        desc: "Poucas coisas, feitas de forma impecável. Cada linha de código precisa justificar sua existência.",
      },
      {
        title: "Transparência radical",
        desc: "Roadmaps públicos, métricas abertas e comunicação honesta. A confiança nasce da clareza.",
      },
      {
        title: "Tecnologia com alma",
        desc: "Experiências que cuidam das pessoas: bonitas, acessíveis e respeitosas por padrão.",
      },
      {
        title: "Feito na América Latina, para todos",
        desc: "Partimos da América Latina, transformando limitações em criatividade, e criamos para pessoas em todo lugar.",
      },
    ],
    futureLabel: "( O Futuro )",
    futureTitle: "Nossa visão de futuro",
    futurePara1:
      "A Avoria nasceu para durar. Não queremos crescer rápido, e sim crescer certo: uma família de ferramentas que ajudam pessoas de forma real e duradoura, conectadas por clareza e propósito.",
    futurePara2:
      "No longo prazo, queremos que Avoria seja um nome em que as pessoas confiam: onde houver algo que mereça ser mais fácil (aprender, conectar, viver), haverá uma ferramenta Avoria para isso.",
  },
  products: {
    eyebrow: "Produtos",
    side: "Nosso primeiro produto",
    title: "Aprenda fazendo, não só lendo",
    sub: "Criamos ferramentas que tornam temas técnicos complexos acessíveis, interativos e realmente divertidos de aprender.",
    linkoLabel: "Aprendizado interativo",
    linkoDesc:
      "Plataforma interativa para aprender Redes e Telecom. Laboratórios práticos, simulações visuais e desafios guiados que transformam protocolos abstratos em habilidades concretas.",
    joinWaitlist: "Entrar na lista de espera",
    requestDemo: "Pedir uma demonstração",
    highlights: [
      { title: "Simulações de rede", desc: "Monte e resolva problemas em topologias reais no navegador." },
      { title: "Desafios gamificados", desc: "Avance por níveis, ganhe distintivos e compita com colegas." },
      { title: "Currículo guiado", desc: "Do básico do modelo OSI a protocolos de roteamento avançados." },
      { title: "Pronto para certificação", desc: "Conteúdo alinhado a CCNA, CompTIA Network+ e mais." },
    ],
    whyLinko: "Por que Linko",
    philosophyLabel: "Filosofia",
    philTitle: "Aprenda protocolos, não só teoria",
    philDesc:
      "Cursos tradicionais ensinam o que é um pacote. O Linko deixa você vê-lo viajar, quebrá-lo, consertá-lo e entender por que importa. Interativo primeiro, teoria depois.",
    builtByLabel: "Feito pela Avoria",
    qualityTitle: "Qualidade acima de quantidade",
    qualityDesc:
      "Cada laboratório é feito à mão, cada simulação testada. Não temos pressa com o conteúdo. Lançamos o que realmente ajuda você a aprender e reter conhecimento no longo prazo.",
  },
  blog: {
    eyebrow: "Diário",
    essays: "{{count}} ensaios",
    line1: "Ideias que",
    line2: "moldam o essencial",
    sub: "Reflexões, ideias e experimentos sobre tecnologia, filosofia e um futuro digital ético.",
    featured: "Destaque",
    readArticle: "Ler artigo",
    read: "Ler",
    more: "Mais do diário",
  },
  blogPost: {
    backToBlog: "Voltar ao blog",
    notFoundLabel: "Erro 404",
    notFoundTitle1: "Post não",
    notFoundTitle2: "encontrado",
    notFoundSub: 'O post "{{slug}}" não existe ou foi movido.',
    theEssay: "O ensaio",
  },
  notFound: {
    label: "Erro 404",
    side: "Página não encontrada",
    subPrefix: "Procuramos em todo lugar por",
    subSuffix: ", mas esta página não existe.",
    back: "Voltar ao início",
    contactPrefix: "Se você acha que isso é um erro,",
    contactLink: "fale com a equipe da Avoria",
  },
  contact: {
    eyebrow: "Contato",
    title1: "Vamos",
    title2: "construir",
    sub: "Conte sobre sua empresa e o que você precisa. Respondemos rápido, com clareza e objetividade.",
    formLabel: "01 / Enviar uma mensagem",
    nameLabel: "Nome",
    namePlaceholder: "Seu nome",
    emailLabel: "E-mail",
    emailPlaceholder: "voce@empresa.com",
    companyLabel: "Empresa",
    companyPlaceholder: "Nome da empresa",
    topicLabel: "Assunto",
    topicLinko: "Linko (aprendizado interativo)",
    topicPartnership: "Parcerias",
    topicSupport: "Suporte",
    topicOther: "Outro",
    messageLabel: "Mensagem",
    messagePlaceholder: "Descreva brevemente seu contexto, objetivos e prazo.",
    consentPre: "Concordo em ser contatado pela Avoria e aceito a",
    privacyPolicy: "Política de Privacidade",
    sending: "Enviando...",
    send: "Enviar mensagem",
    sendEmail: "Enviar e-mail",
    responseNote: "Normalmente respondemos em 1-2 dias úteis.",
    otherLabel: "02 / Outros canais",
    otherTitle1: "Prefere falar",
    otherTitle2: "diretamente",
    emailChannel: "E-mail",
    questionsChannel: "Dúvidas",
    faq: "Perguntas frequentes",
    asideNote: "Guardamos só o essencial. Sem spam. Você pode pedir a remoção dos dados a qualquer momento.",
    validation: {
      nameRequired: "Por favor, informe seu nome.",
      emailInvalid: "Por favor, informe um e-mail válido.",
      messageRequired: "Por favor, escreva uma mensagem.",
      consentRequired: "Você precisa aceitar a política de contato.",
      sendFailed: "Não foi possível enviar.",
    },
    toastSuccess: "Mensagem enviada! Retornaremos em breve.",
    toastError: "Não foi possível enviar agora. Tente novamente.",
  },
  seo: {
    home: {
      title: "Avoria | Tecnologia para pessoas",
      desc: "A Avoria cria softwares e ferramentas que ajudam pessoas: no social, no educacional e além. Feito no Brasil, para todos.",
    },
    about: {
      title: "Sobre | Avoria",
      desc: "A filosofia por trás da Avoria: criar softwares e ferramentas que realmente ajudam pessoas, com clareza, ética e propósito.",
    },
    products: {
      title: "Produtos | Avoria",
      desc: "Linko, nosso primeiro produto: aprendizado interativo e prático de redes e telecom. Aprenda fazendo, não só lendo.",
    },
    blog: {
      title: "Blog | Avoria",
      desc: "Ideias, reflexões e experimentos sobre tecnologia, filosofia e um futuro digital ético, da equipe Avoria.",
    },
    contact: {
      title: "Contato | Avoria",
      desc: "Conte sobre seu projeto. Social, educacional ou algo novo: se ajuda pessoas, queremos ouvir você.",
    },
    notFound: {
      title: "Página não encontrada | Avoria",
      desc: "A página que você procura não existe. Volte para a página inicial da Avoria.",
    },
  },
  privacy: {
    metaTitle: "Política de Privacidade | Avoria",
    metaDesc: "Como a Avoria coleta, usa e protege seus dados. Privacidade por padrão, alinhada à LGPD.",
    eyebrow: "Jurídico",
    title: "Política de Privacidade",
    updated: "Atualizado em junho de 2026",
    intro: "Privacidade é um dos valores centrais da Avoria, não um detalhe de última hora. Esta página explica, em linguagem simples, o que coletamos e por quê.",
    sections: [
      { h: "O que coletamos", p: "Apenas o mínimo necessário: os dados que você envia pelo formulário de contato (nome, e-mail, empresa, assunto e mensagem) e métricas agregadas e amigáveis à privacidade, sem cookies e sem perfilamento pessoal." },
      { h: "Por que coletamos", p: "Para responder a você (com base no seu consentimento) e para entender, de forma agregada, como o site é usado (legítimo interesse). Nada além disso." },
      { h: "Por quanto tempo guardamos", p: "As mensagens de contato são mantidas apenas pelo tempo necessário para atender sua solicitação e depois apagadas. As métricas agregadas não contêm dados pessoais." },
      { h: "Seus direitos (LGPD)", p: "Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelo e-mail contact@avoria.com. Respondemos em prazo razoável." },
      { h: "Segurança", p: "Coleta mínima, criptografia em trânsito e acesso apenas a quem precisa. Privacidade por padrão é um dos nossos princípios fundadores." },
      { h: "Terceiros", p: "Nunca vendemos seus dados. Usamos um provedor de métricas sem cookies e provedores de infraestrutura padrão, todos obrigados a proteger suas informações." },
      { h: "Alterações", p: "Se esta política mudar, atualizaremos esta página e a data acima." },
    ],
  },
  faq: {
    metaTitle: "Perguntas frequentes | Avoria",
    metaDesc: "Respostas sobre a Avoria, o Linko, privacidade, idiomas e como falar com a gente.",
    eyebrow: "Ajuda",
    title: "Perguntas frequentes",
    sub: "Respostas curtas e honestas. Ainda com dúvida? É só falar com a gente.",
    items: [
      { q: "O que é a Avoria?", a: "A Avoria é um estúdio de tecnologia que cria softwares e ferramentas para ajudar pessoas, em contextos sociais, educacionais e do dia a dia. O Linko é nosso primeiro produto." },
      { q: "O que é o Linko?", a: "O Linko é uma plataforma interativa e prática para aprender redes e telecom: laboratórios, simulações visuais e desafios guiados. Você aprende fazendo, não só lendo." },
      { q: "Quando o Linko será lançado?", a: "Estamos construindo com calma e em público. Entre na lista de espera pela página de Produtos para ser o primeiro a saber." },
      { q: "Como vocês tratam meus dados?", a: "Privacidade por padrão: coletamos o mínimo, nunca vendemos seus dados e usamos métricas sem cookies. Veja a Política de Privacidade para os detalhes." },
      { q: "Posso pedir a exclusão dos meus dados?", a: "Sim. Envie um e-mail para contact@avoria.com e removeremos seus dados. É seu direito pela LGPD." },
      { q: "Em quais idiomas o site está disponível?", a: "Inglês e português do Brasil. Use o seletor EN / PT no cabeçalho." },
      { q: "Como trabalhar com ou falar com a Avoria?", a: "Use o formulário de contato ou escreva para contact@avoria.com. Normalmente respondemos em 1-2 dias úteis." },
    ],
  },
};
